export default "__VITE_PUBLIC_ASSET__fa06d3af__"